

class PreventUnsaved extends HTMLElement {
	static returnValue = 'Er du sikker på du vil forlade siden? Du har muligvis ændringer som ikke er gemt';
	static get observedAttributes() {
		return ['isdirty'];
	}

	isDirty() {
		return this.getAttribute('isdirty') === 'true';
	}

	handleUnload(event: BeforeUnloadEvent) {
		if (this.isDirty()) {
			event.preventDefault();
			event.returnValue = PreventUnsaved.returnValue;
		}
	}

	handleEventListener(forceRemove?: boolean) {
		if (this.isDirty() && !forceRemove) {
			window.addEventListener('beforeunload', (e) => this.handleUnload(e), { once: true });
		} else {
			window.removeEventListener('beforeunload', (e) => this.handleUnload(e));
		}
	}

	attributeChangedCallback(name, oldValue, newValue) {
		if (name === 'isdirty' && oldValue !== newValue) {
			this.handleEventListener();
		}
	}

	connectedCallback() {
		this.innerHTML = '';
		this.handleEventListener();
	}

	disconnectedCallback() {
		this.handleEventListener(true);
	}
}

export const name = 'prevent-unsaved';

if (!window.customElements?.get(name)) {
	window.customElements.define(name, PreventUnsaved);
}